import type { SVGProps } from 'react';
const SvgIconBulb = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M9.75 13.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 1c3.488 0 6.5 2.48 6.5 5.75 0 1.87-1.005 3.496-2.502 4.531a1.75 1.75 0 0 1-1.57 1.71L10.25 13h-4.5a1.75 1.75 0 0 1-1.749-1.719C2.504 10.246 1.5 8.621 1.5 6.75 1.5 3.48 4.512 1 8 1m0 1.5c-2.863 0-5 1.998-5 4.25 0 1.406.813 2.691 2.135 3.48l.365.218v.802l.005.05a.25.25 0 0 0 .245.2h1.5v-3h-.5a.75.75 0 0 1 0-1.5h2.5a.75.75 0 0 1 0 1.5h-.5v3h1.5l.05-.005a.25.25 0 0 0 .2-.245v-.802l.365-.218C12.187 9.442 13 8.156 13 6.75c0-2.252-2.137-4.25-5-4.25"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconBulb;
